// Internal GraphQL fetch wrapper for aicrowd-ui hooks. Handles CSRF token,
// X-Preview-Mode header forwarding, and a single shape across all hook calls.
//
// Posts to /graphql, which is added by the dynamic-components feature
// (admin auth required by default; preview mode for admins with the
// X-Preview-Mode header).

export interface GraphqlRequest {
  query: string;
  variables?: Record<string, unknown>;
  headers?: Record<string, string>;
}

export interface GraphqlResponse<T = unknown> {
  data?: T;
  errors?: Array<{ message: string; locations?: Array<{ line: number; column: number }>; path?: string[] }>;
}

export async function fetchGraphql<T = unknown>({ query, variables, headers }: GraphqlRequest): Promise<GraphqlResponse<T>> {
  const csrfMeta = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null;
  const csrf = (csrfMeta && csrfMeta.content) || '';
  const previewHeader = (window as unknown as { __AICROWD_PREVIEW_MODE__?: boolean }).__AICROWD_PREVIEW_MODE__
    ? { 'X-Preview-Mode': 'true' }
    : {};

  const res = await fetch('/graphql', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf,
      ...previewHeader,
      ...(headers || {})
    },
    credentials: 'same-origin',
    body: JSON.stringify({ query, variables: variables ? JSON.stringify(variables) : undefined })
  });

  return res.json();
}
